import { createExternalRouteRef } from '@backstage/core-plugin-api';

export const marketplaceProductExternalRouteRef = createExternalRouteRef({
  id: 'marketplace-product-external-ref',
  params: ['id'],
});
